import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccountService } from '@clean-code/shared/auth/util-auth';
import { provideAzureAuth } from '@clean-code/shared/auth/util-azure';
import { SideNavService } from '@clean-code/shared/templates/ui-tailwind-full-width';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { navigationItems } from './navigaton';
import { DashboardModule } from './pages/dashboard/dashboard.module';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    DashboardModule,
  ],
  providers: [
    provideAzureAuth(environment.auth),
    // LocaleProvider, //translations, pipes, etc.
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: MatPaginatorIntl,
    //   useClass: MatPaginationIntlService,
    // },
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandlerService,
    // },
    // {
    //   provide: USER_LIMIT_SERVICE,
    //   useClass: UserLimitPersonalService,
    // },
    // SideNavService,
    // RxState<SplashScreenState>,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor() {
    const sideNavService = inject(SideNavService);
    const _accountService = inject(AccountService);

    sideNavService.addNavigation(navigationItems);
  }
}
